import React from 'react';
import { isMockTestLocked } from '../utils/subscriptionUtils';

const MockTestList = ({ tests, accessibleTests, onSelectTest, isPremium }) => {
  return (
    <div className="mock-test-list">
      <div className="list-header">
        <h2>Mock Tests</h2>
        <p className="list-subtitle">
          {isPremium 
            ? 'Practice with 5 comprehensive mock tests - 30 questions each' 
            : `You have access to ${accessibleTests.length} of ${tests.length} mock tests`
          }
        </p>
      </div>

      <div className="tests-grid">
        {tests.map((test) => {
          const isLocked = !isPremium && test.id > 3;
          
          return (
            <div 
              key={test.id}
              className={`test-card ${isLocked ? 'locked' : ''}`}
              onClick={() => onSelectTest(test.id)}
            >
              {isLocked && (
                <div className="lock-badge">
                  <span className="lock-icon">🔒</span>
                  <span className="lock-text">Premium Only</span>
                </div>
              )}
              
              <div className="test-card-header">
                <h3 className="test-title">{test.title}</h3>
                <span className="test-badge">{test.id}/5</span>
              </div>

              <p className="test-description">{test.description}</p>

              <div className="test-details">
                <div className="detail-item">
                  <span className="detail-label">Questions:</span>
                  <span className="detail-value">{test.questions.length}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Time:</span>
                  <span className="detail-value">{(test.questions.length * 90) / 60 |0} min</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Pass Score:</span>
                  <span className="detail-value">83% (25 Q)</span>
                </div>
              </div>

              <button className="test-button">
                {isLocked ? 'Unlock with Premium' : 'Start Test'} <span className="arrow">→</span>
              </button>
            </div>
          );
        })}
      </div>

      <div className="test-info-section">
        <div className="info-card">
          <h3>📋 How Mock Tests Work</h3>
          <ul>
            <li>30 questions per test</li>
            <li>Multiple choice format</li>
            <li>Approximately 90 seconds per question</li>
            <li>Instant feedback after submission</li>
            <li>Retake tests unlimited times</li>
          </ul>
        </div>

        <div className="info-card">
          <h3>✅ Passing Criteria</h3>
          <ul>
            <li>You must score 83% or higher</li>
            <li>That means 25 out of 30 questions correct</li>
            <li>Review your results for areas to improve</li>
            <li>Retake tests to boost your confidence</li>
          </ul>
        </div>

        <div className="info-card">
          <h3>💡 Tips for Success</h3>
          <ul>
            <li>Read questions carefully</li>
            <li>Manage your time effectively</li>
            <li>Review before submitting</li>
            <li>Focus on weak areas</li>
            <li>Practice regularly</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MockTestList;
